import React from 'react';
import { motion } from 'framer-motion';
export function OtlParamoExample() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="mb-24 grid grid-cols-1 lg:grid-cols-12 gap-0 bg-forest text-bone overflow-hidden" data-id="element-375" data-mp="i744r3w8wg5f">
      <div className="lg:col-span-5 relative min-h-[300px] lg:min-h-0" data-id="element-376" data-mp="r6znbts4rdfh">
        <img src="https://cdn.magicpatterns.com/uploads/b3XxDpPc3kRjBQ4H7ZEj2X/paramo.jpg" alt="Páramo andino con frailejones" className="absolute inset-0 w-full h-full object-cover" data-id="element-377" data-mp="3qnfo4y7qv43d" />
      </div>
      <div className="lg:col-span-7 p-8 md:p-12 lg:p-16" data-id="element-378" data-mp="3iq32wakexqg">
        <span className="text-clay-light text-xs uppercase tracking-[0.2em] font-semibold mb-3 block" data-id="element-379" data-mp="3h5b9efmxswa">
          Un ejemplo sencillo
        </span>
        <h3 className="font-serif text-3xl md:text-4xl mb-6 leading-tight" data-id="element-380" data-mp="36zq8fpd30uai">
          Los páramos
        </h3>
        <div className="space-y-4 text-bone/80 font-light leading-relaxed mb-10" data-id="element-381" data-mp="3bxhwu9eipy9y">
          <p data-id="element-382" data-mp="3lztb4jxag1yn">
            Los páramos son ecosistemas de alta montaña fundamentales para la
            vida. Tienen una gran capacidad para captar, almacenar y regular el
            agua, por lo que abastecen a millones de personas y cumplen un papel
            clave frente al cambio climático.
          </p>
          <p data-id="element-383" data-mp="388ohpzkik5wr">
            Cuando un páramo se reconoce y delimita como OTL, su protección deja
            de ser una idea general y se convierte en una regla concreta sobre
            el territorio. Esto permite identificar sus límites, conocer la
            norma que lo respalda y orientar las decisiones públicas y privadas
            que puedan afectarlo.
          </p>
          <p data-id="element-384" data-mp="2p9ajh5fr490g">
            En estos casos, los OTL permiten reconocer tres elementos
            principales:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-385" data-mp="sfftcnehfakb">
          <div data-id="element-386" data-mp="nhxj8toqapaq">
            <div className="text-clay-light text-xs font-bold uppercase tracking-wider mb-3 border-b border-bone/20 pb-2" data-id="element-387" data-mp="nhebu6wpfjay">
              Derechos
            </div>
            <p className="text-bone/80 text-sm font-light leading-relaxed" data-id="element-388" data-mp="1bczh79ju8cbd">
              Asociados a la protección del agua, la biodiversidad y los
              servicios ecosistémicos que benefician a la sociedad.
            </p>
          </div>
          <div data-id="element-389" data-mp="12lqqml40y1ng">
            <div className="text-clay-light text-xs font-bold uppercase tracking-wider mb-3 border-b border-bone/20 pb-2" data-id="element-390" data-mp="12l78b3agpb8w">
              Restricciones
            </div>
            <p className="text-bone/80 text-sm font-light leading-relaxed" data-id="element-391" data-mp="1uc53ce0ax7xj">
              Relacionadas con actividades que pueden afectar el equilibrio
              ambiental, como ciertos usos mineros, urbanísticos o productivos.
            </p>
          </div>
          <div data-id="element-392" data-mp="4wx7grmewtjd">
            <div className="text-clay-light text-xs font-bold uppercase tracking-wider mb-3 border-b border-bone/20 pb-2" data-id="element-393" data-mp="4x71cqakvkuc">
              Responsabilidades
            </div>
            <p className="text-bone/80 text-sm font-light leading-relaxed" data-id="element-394" data-mp="9tnn5dub1n49">
              Compartidas entre el Estado, las comunidades y la sociedad para
              conservar, restaurar y cuidar estos territorios.
            </p>
          </div>
        </div>
      </div>
    </motion.div>;
}